/* eslint-disable react/prop-types */
import React from 'react'
import nookies from 'nookies'
import Head from 'next/head'
import * as catalogApi from '@api/catalog'
import Loyalty from '../../src/components/Pages/Company/Loyalty/Loyalty'
import { createGSSP, pageStarted } from 'src/pages/shared/bindings'
import MobileDetect from 'mobile-detect'

export default function LoyaltyIndex(props) {
    return (
        <React.Fragment>
            <Head>
                <title>Программа лояльности в сети аптек ЗДОРОВ.ру</title>
            </Head>
            <Loyalty bonusCartsCampaign={props.bonusCartsCampaign} giftCardsCampaigns={props.giftCardsCampaigns} />
        </React.Fragment>
    )
}

export const getServerSideProps = createGSSP({
    pageEvent: pageStarted,
    async customize({ scope, context }) {
        const cookies = nookies.get(context)
        const shipmentCookie = cookies['storage-shipment']
        const shipment = shipmentCookie ? JSON.parse(shipmentCookie) : { stockId: 0, cityId: 1 }
        const md = new MobileDetect(context.req.headers['user-agent'])
        const bonusCartsCampaign = await catalogApi.getBonusCartsCampaign(shipment)
        const giftCardsCampaigns = await catalogApi.getGiftCardsCampaigns(shipment)
        return { props: { bonusCartsCampaign, giftCardsCampaigns, mobile: md.mobile() } }
    }
})
